module.exports = __webpack_public_path__ + "static/media/dodgem(20).439b4137.PNG";